import airlines from './airlines'
import airports from './airports'
import filters from './filters'
import gozocabs from './gozocabs'
import locations from './locations'
import others from './others'
import quote from './quote'
import selected from './selected'
import settings from './settings'

export default {
  strict: false,
  namespaced: true,
  state: Object.assign(
    airlines.state,
    airports.state,
    filters.state,
    gozocabs.state,
    locations.state,
    others.state,
    quote.state,
    selected.state,
    settings.state
  ),
  mutations: Object.assign(
    airlines.mutations,
    airports.mutations,
    filters.mutations,
    gozocabs.mutations,
    locations.mutations,
    others.mutations,
    quote.mutations,
    selected.mutations,
    settings.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/booking/index.js